import { StyledFooter, StyledTitle, StyledText } from './Footer.styles';

function Footer() {
  return (
    <StyledFooter>
      <StyledTitle>Robin Srl &ndash; Società soggetta a direzione e coordinamento di <a href="https://www.monrif.it/" >Monrif</a></StyledTitle>
      <StyledText>Copyright&copy; 2021 &ndash; P.Iva 12741650159</StyledText>
    </StyledFooter>
  );
}

export default Footer;
